export const getFaviconUrl = (url) => {
    let faviconUrl;

    const regex = /^https?:\/\/[^/]+/;
    const match = url.match(regex);

    if (match) {
        faviconUrl = match[0] + '/';
    } else {
        faviconUrl = url;
    }

    faviconUrl += 'favicon.ico';

    // t0, t1, t2
    return `https://t${Math.floor(
        Math.random() * 3
    )}.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${faviconUrl}&size=16`;
};
